module.exports = __webpack_public_path__ + "img/company-xh.bb477b51.png";